// extracted by mini-css-extract-plugin
export default {"chipStackCell":"eB_eC","chipStackCell__revolver":"eB_eE","chipStackCell__revolver_hidden":"eB_eF","chipStackCell_close":"eB_eG"};